import axios from 'axios'

const SESSION_NAME = 'swsession'

const getToken = () => JSON.parse(window.localStorage.getItem(SESSION_NAME))

const setToken = (token) => {
  axios.defaults.headers.Authorization = `Bearer ${token}`
  window.localStorage.setItem(SESSION_NAME, JSON.stringify(token))
}
const setSplashscreenLoaded = () => {
 // window.localStorage.setItem('tiketeraSplashScreen', JSON.stringify(true))
}

//const getSplashscreenLoaded = () => JSON.parse(window.localStorage.getItem('tiketeraSplashScreen'))

const setData = (data) => {
  //window.localStorage.setItem('tiketeraData', JSON.stringify(data))
}

const getData = () => JSON.parse(window.localStorage.getItem('swData'))

const removeToken = () => {
  delete axios.defaults.headers.Authorization
  window.localStorage.removeItem(SESSION_NAME)
}

const loadModule = (mod, user = null, business = null) => {
  import(/* webpackChunkName: "[request]" */ './' + mod + '/main').then(x => x.render(user, business))
}

const arrayRemoveDupes = (array) => {
  const newArray = []
  array.forEach(x => { if (!newArray.includes(x)) newArray.push(x) })
  return newArray
}

const closeSpashscreen = (vue) => {
  const diff = (new Date()) - vue.startTime
  const wait = 4000 - diff < 0 ? 0 : 4000 - diff
  //setTimeout(() => { document.getElementById('splashscreen').className = 'splashscreen-close' }, wait)
}

export {
  getToken,
  setToken,
  setSplashscreenLoaded,
  arrayRemoveDupes,
  getData,
  setData,
  removeToken,
  loadModule,
  closeSpashscreen
}
